import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            {contactInfo.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {contactInfo.description}
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-5 mb-8">
            <div className="flex items-center justify-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
                <span className="text-sm font-medium text-foreground-800">{contactInfo.email}</span>
              </div>
            </div>

            <div className="flex items-center justify-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-wechat-line text-lg text-accent-500"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-400 mb-0.5">微信公众号</div>
                <span className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</span>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {contactInfo.tips.map((tip) => (
              <span
                key={tip}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-500 whitespace-nowrap"
              >
                <i className="ri-information-line text-accent-400"></i>
                {tip}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}